import { render, staticRenderFns } from "./VehicleIcon.vue?vue&type=template&id=499cda78&"
import script from "./VehicleIcon.vue?vue&type=script&lang=js&"
export * from "./VehicleIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports